import React, { useEffect, useState, useCallback } from "react";
import AccountsLayout from "../AccountsLayout";
import { useLocation, useParams } from "react-router-dom";
import { useStore } from "../../../Components/StateProvider";
import {
    baseurl,
    RupeeFormat,
    URLPRIFIX,
    GetStatusCounts,
    ErrorAlert
} from "../../../functions/api";
import Filters from "../../../Components/Fields/Filters";
import {
    FaBackwardFast,
    FaBackwardStep,
    FaForwardFast,
    FaForwardStep,
} from "react-icons/fa6";
import {
    URL_Account_Invoice_List,
} from "../../../Constancs/apiconst";
import axios from "axios";
import { getlocal } from "../../../functions/localstorage";
import StatusTabs from "../../../Components/Elements/StatusTabs";
import Pagination from "../../../Components/Fields/Pagination";
import ListViewUp from "../../../Components/Elements/ListViewUp";

const InvoiceListUpdated = () => {
    const location = useLocation();
    const { companyId } = useParams();
    const queryParams = new URLSearchParams(location.search);
    const tablename = "companies";
    const statusCountURL = "/api/v2/invoice/getinvoicetatuscount/" + companyId;
    const [statusTabs, setStatusTabs] = useState([]);
    const [activeTab, setActiveTab] = useState("ALL");
    const [filters, setFilters] = useState({});
    const [hasTabClicked, setHasTabClicked] = useState(false);
    const [sortConfig, setSortConfig] = useState({ field: null, direction: 'asc' });
    const [selectedRecords, setSelectedRecords] = useState([]);


    const Header = [
        ["Invoice No", "invoice_no", "w-[250px]"],
        ["Customer", "clientname", "w-[150px]"],
        ["Amount", "invoice_total"],
        ["Due Amount", "invoice_due_amount"],
        ["Status", "invoice_status"],
        ["Invoice Date", "invoice_date"],
        ["Due Date", "invoice_due_date"],
        ["Created Date", "created_date"],
        ["Action", "ACTION"],
    ];

    const store = useStore();
    const init = {
        filterfield: "all",
        search: "",
        sort: "desc",
        currentpage: 1,
        totalpage: 1,
        pagesize: 20,
    };

    // State for filtered records that will be passed to ListView
    const [filteredRecords, setFilteredRecords] = useState([]);

    useEffect(() => {
        store.setmodule("invoices", init).then(() => {
            fetchStatusCounts();
            store.stopLoading();
            store.setheader(tablename + " List");
            var states = store.state.records.invoices;
            GetListview({
                listUrl: URL_Account_Invoice_List + companyId,
                store: store,
                field: queryParams.get("field") || states?.filterfield,
                search: queryParams.get("search") || states?.search,
                sort: queryParams.get("sort") || states?.sort,
                pagesize: queryParams.get("pagesize") ?? store.getvalue("pagesize") ?? init.pagesize,

            });
        });
    }, [companyId]);

    const fetchStatusCounts = useCallback(async () => {
        store.startLoading();
        try {
            const counts = await GetStatusCounts(statusCountURL, store);
            if (counts?.statuscount) {
                setStatusTabs(counts.statuscount);
            }
        } catch {
            ErrorAlert("Failed to fetch status counts.");
        } finally {
            store.stopLoading();
        }
    }, [statusCountURL, store]);

    const handleSort = useCallback((field) => {
        let direction = 'asc';
        if (sortConfig.field === field && sortConfig.direction === 'asc') {
            direction = 'desc';
        }
        setSortConfig({ field, direction });

        change({
            field: field,
            search: filters[field] || "", // Use existing filter for the field
            sort: direction,
            page: store.getvalue("currentpage") || 1,
            pagesize: store.getvalue("pagesize") // Maintain current page
        });
    }, [sortConfig, filters, store]);

    const handleFilterChange = useCallback((field, value) => {
        setFilters(prevFilters => ({
            ...prevFilters,
            [field]: value,
        }));

        // Trigger data fetch with new filter value
        change({
            field: field,
            search: value,
            sort: sortConfig.direction,
            page: 1, // Reset to first page on filter change
        });
    }, [sortConfig, store]);


    function change(props) {
        console.log("search data - ", props);
        GetListview({
            listUrl: URL_Account_Invoice_List + companyId,
            store: store,
            field: props.field,
            search: props.search,
            sort: props.sort,
            page: props.page || store.getvalue("currentpage") || 1,
            pagesize: props.pagesize || store.getvalue("pagesize") || init.pagesize,
        });
    }

    function onpage(page, newSize = store.getvalue("pagesize")) {
        const currentFilters = store.getvalue("filters") || {};
        const filterField = Object.keys(currentFilters)[0] || "all";
        const filterSearch = currentFilters[filterField] || "";

        GetListview({
            listUrl: URL_Account_Invoice_List + companyId,
            store: store,
            field: filterField,
            search: filterSearch,
            sort: sortConfig.direction,
            page: page,
            pagesize: newSize, // Pass the new size from pagination component
        });
    }

    function GetListview({
        listUrl = "",
        field = "",
        search = "",
        sort = "",
        page = 1,
        count = 20, // This 'count' parameter seems unused in the URL construction for pagination logic
        pagesize = 20,
        store,
    }) {
        let token = getlocal("system").token;
        let url = "";
        if (field !== "") url += "&fieldname=" + field;
        if (search !== "") url += "&search=" + search;
        if (sort !== "") url += "&sort=" + sort;
        if (page !== "") url += "&page=" + page;
        if (count !== "") url += "&count=" + count; // This might be problematic if 'count' is meant to be the total count, but 'pagesize' is used for pagination.
        if (pagesize !== "") url += "&pagesize=" + pagesize;
        url = url.substring(1, url.length);
        url = `${baseurl}${listUrl}?${url}`;

        axios
            .get(url, {
                headers: { Authorization: `Bearer ${token}` },
            })
            .then((res) => {
                console.log("GetListview responce - ", res);
                res = res?.data;

                console.log("check1",res)
                // Ensure totalCount from the API is a number, default to 0 if not present
                const totalItems = res?.totalCount ? parseInt(res.totalCount, 10) : 0;
                console.log("check2 totalitems",totalItems)

                const currentPagesize = pagesize > 0 ? pagesize : init.pagesize;
                console.log("check3 currentpagesize",totalItems)



                let totalPages = 0;
                if (currentPagesize > 0) { // Prevent division by zero
                    totalPages = Math.ceil(totalItems / currentPagesize);
                }

                // transformedList and other logic remain the same
                const transformedList = res.list.map((item) => {
                    // ... (your existing switch case for invoice_status)
                    switch (item.invoice_status) {
                        case "paid":
                            item.invoice_status = "Paid";
                            break;
                        case "awaitingtds":
                            item.invoice_status = "Awaiting TDS";
                            break;
                        case "completed":
                            item.invoice_status = "Completed";
                            break;
                        case "cancelled":
                            item.invoice_status = "Cancelled";
                            break;
                        case "paidwithtds":
                            item.invoice_status = "Paid with TDS";
                            break;
                        case "draft":
                            item.invoice_status = "Draft";
                            break;
                        default:
                            item.invoice_status = "Unknown";
                            break;
                    }
                    return item;
                });

                store.setvalue("totalpage", totalPages); // This stores the calculated number of pages
                store.setvalue("currentpage", page);
                store.setvalue("pagesize", currentPagesize); // Ensure pagesize is correctly set in store
                store.setvalue("list", transformedList);
                // Also store the total number of items, which the Pagination component might need
                store.setvalue("totalrecords", totalItems); // <-- Add this
                setFilteredRecords(transformedList);
            })
            .catch((res) => {
                console.log("Error Response", res);
                // Optionally, set default values to prevent NaN in pagination on error
                store.setvalue("totalpage", 1);
                store.setvalue("currentpage", 1);
                store.setvalue("pagesize", init.pagesize);
                store.setvalue("totalitems", 0);
                setFilteredRecords([]);
            });
    }

    const handleTabClick = useCallback((status, count) => {
        console.log("tab clicked", status);
        console.log("tab clicked count", count);

        const field = "invoice_status";
        const search = status.toUpperCase() === "ALL" ? "" : status;
        setActiveTab(status);
        setHasTabClicked(true);
        store.setvalue("ActiveTab", status);
        store.setvalue("TabClicked", true);
        // store.setvalue("pagesize", count); // Remove or comment out this line

        const newFilters = status.toUpperCase() === "ALL" ? {} : { [field]: search };
        setFilters(newFilters);
        store.setvalue("filters", newFilters);

        GetListview({
            listUrl: URL_Account_Invoice_List + companyId,
            store: store,
            field: field,
            search: search,
            sort: sortConfig.direction,
            page: 1,
            pagesize: count, // Pass the 'count' directly here
        });
    }, []);


    const handleClearFilter = useCallback(() => {
        setActiveTab("ALL");
        setFilters({});
        setHasTabClicked(false);
        store.setvalue("filters", {});
        store.setvalue("pagesize", init.pagesize);
        store.setvalue("filterfield", init.filterfield);
        store.setvalue("search", init.search);
        store.setvalue("sort", init.sort);
        store.setvalue("currentpage", init.currentpage);
        store.setvalue("ActiveTab", "ALL");
        store.setvalue("TabClicked", false);

        // Call GetListview to refetch all records without filters
        GetListview({
            listUrl: URL_Account_Invoice_List + companyId,
            store: store,
            field: init.filterfield,
            search: init.search,
            sort: init.sort,
            page: init.currentpage,
            pagesize: init.pagesize,
        });
    }, [companyId, store, init]);


    const handleDeleteRecord = useCallback(async (item) => {
        if (window.confirm(`Are you sure you want to delete invoice no. ${item.invoice_no}?`)) {
            store.startLoading();
            try {
                // const token = getlocal("system").token;
                // const deleteUrl = `${baseurl}${DeleteURL}${item.id}`; // Assuming DeleteURL is defined
                // await axios.delete(deleteUrl, {
                //     headers: { Authorization: `Bearer ${token}` },
                // });
                // ErrorAlert("Invoice deleted successfully!");
                // Re-fetch data after deletion
                // onpage(store.getvalue("currentpage"));
            } catch (error) {
                console.error("Error deleting invoice:", error);
                ErrorAlert("Failed to delete invoice.");
            } finally {
                store.stopLoading();
            }
        }
    }, [store, onpage]); // Added DeleteURL to dependencies

    const handleRowClick = useCallback((item) => {
        // This function will be called when a row is clicked (excluding checkbox and action buttons)
        if (store.getprops("view")) {
            store.navTo(
                "/" +
                URLPRIFIX +
                "/" +
                companyId +
                "/accounts/invoice/view/" +
                item.id
            );
        }
    }, [companyId, store]);

    const handleOnSelect = useCallback((record, isChecked) => {
        setSelectedRecords((prevSelected) => {
            if (isChecked) {
                return [...prevSelected, record];
            } else {
                return prevSelected.filter((item) => item.id !== record.id);
            }
        });
    }, []);

    const isSelected = useCallback((record) => {
        return selectedRecords.some((item) => item.id === record.id);
    }, []);

    const handleSelectAll = useCallback((event) => {
        if (event.target.checked) {
            setSelectedRecords(filteredRecords);
        } else {
            setSelectedRecords([]);
        }
    }, []);

    const isAllSelected = filteredRecords.length > 0 && selectedRecords.length === filteredRecords.length;

  const Tablehead =
        " pr-[10px] max-sm:text-[26px] md:text-[20px] lg:text-[16px] xl:text-[20px] font-bold ";
    const Tablerecord =
        " pr-[10px] max-sm:text-[26px] md:text-[20px] lg:text-[12px] xl:text-[16px] overflow-hidden";

    return (
        <div className="grid grid-rows-10 h-full ">
      <div className="flex flex-wrap justify-between items-center mb-2 m-8 px-2">
                <StatusTabs
                    statusTabs={statusTabs}
                    activeTab={activeTab}
                    onTabClick={handleTabClick}
                    hasTabClicked={hasTabClicked}
                    onClearClick={handleClearFilter}
                />
                {store.getprops("add") && (
                    <div className="absolute right-10 top-5">
                        <button
                            className="bg-primary text-secondary py-2 text-[12px] px-6 rounded-3xl"
                            onClick={() => {
                                store.removemodule(
                                    tablename.substring(0, tablename.length - 1)
                                );
                                store.navTo(
                                    "/" + URLPRIFIX + "/" + companyId + "/accounts/invoice/create"
                                );
                            }}
                        >
                 ➕ ADD INVOICE
                        </button>
                    </div>
                )}
            </div>
              <div className="row-span-9 h-full w-full ">
                <div className="py-5 px-[40px] h-full  w-full" contentEditable={false}>
                    <ListViewUp
                        header={Header}
                        filteredRecords={filteredRecords} // Pass the local state
                        Tablehead={Tablehead} // Example class, adjust as needed
                        Tablerecord={Tablerecord}
                        sortConfig={sortConfig}
                        handleSort={handleSort}
                        filters={filters}
                        onFilterChange={handleFilterChange}
                        store={store}
                        handleOnSelect={handleOnSelect}
                        isSelected={isSelected}
                        handleClickRow={handleRowClick} // Pass the new row click handler
                        handleDelete={handleDeleteRecord} // Pass the delete handler
                        handleSelectAll={handleSelectAll}
                        isAllSelected={isAllSelected}
                        tablename="invoices" // Changed to "invoices" as it's an invoice list
                        currentPage={store.getvalue("currentpage")}
                        pageSize={store.getvalue("pagesize")}
                    />
                    <div className="float-right mr-8 mt-6">
                        <Pagination onchange={onpage} />
                    </div>
                </div>
            </div>
        </div>
    );

};

export default InvoiceListUpdated;

